import React from "react";
import { trackLeadMagnetClick } from "../../utils/analytics";

const variants = {
  trial: {
    eyebrow: "Free trial",
    title: "Попробуйте Энилекс.Контроль бесплатно 14 дней",
    description:
      "Один рабочий контур для задач, изменений, аналитики и контроля seller-команды по SKU.",
    button: "Запустить пилот",
  },
  checklist: {
    eyebrow: "Checklist",
    title: "Скачайте чек-лист по оптимизации карточки",
    description:
      "10 шагов для SEO, визуала и ставок, которые команда может пройти за один спринт.",
    button: "Получить чек-лист",
  },
  demo: {
    eyebrow: "Demo",
    title: "Покажем демо под ваш ассортимент",
    description:
      "Разберем, как собрать дашборд под ваши SKU, рекламу и категорийные отчеты.",
    button: "Запросить демо",
  },
};

function LeadMagnet({ variant = "trial", sticky = false, onClose, cta = null }) {
  // Если к статье подобран инструмент и выпущен промокод, предлагаем его,
  // а не общий пилот: конкретика под тему статьи конвертит лучше
  const promo = cta?.url
    ? {
        eyebrow: cta.promoCode ? `Промокод ${cta.promoCode}` : "Инструмент по теме",
        title: cta.promoAmount
          ? `${cta.promoAmount.toLocaleString("ru-RU")} ₽ на баланс новым пользователям`
          : cta.toolTitle,
        description:
          cta.note ||
          `Инструмент «${cta.toolTitle}» закрывает задачу, разобранную в статье.`,
        button: "Забрать промокод",
        href: cta.url,
      }
    : null;
  // Без промокода блок не показываем вовсе: общий призыв «Free trial» в каждой
  // статье выглядел баннером и не давал ни атрибуции, ни конкретики
  if (!promo) {
    return null;
  }

  const content = promo;

  return (
    <aside
      className={`lead-magnet${sticky ? " lead-magnet--sticky" : ""}`}
      data-testid="lead-magnet"
    >
      <div>
        <div className="lead-magnet__eyebrow">{content.eyebrow}</div>
        <h2 className="lead-magnet__title">{content.title}</h2>
        <p className="lead-magnet__description">{content.description}</p>
      </div>
      <a
        className="lead-magnet__button btn"
        href={content.href || "/"}
        onClick={() =>
          trackLeadMagnetClick({
            variant: promo ? "article_promo" : variant,
            placement: sticky ? "sticky" : "inline",
            promo_code: cta?.promoCode || "",
          })
        }
      >
        {content.button}
      </a>
      {sticky ? (
        <button
          type="button"
          className="lead-magnet__close"
          onClick={() => {
            trackLeadMagnetClick({
              variant,
              placement: "sticky_close",
            });
            onClose?.();
          }}
          aria-label="Закрыть нижний CTA"
        >
          Закрыть
        </button>
      ) : null}
    </aside>
  );
}

export default LeadMagnet;
